// src/pages/home/HomePage.jsx
import React, { useState, useEffect } from 'react';
import HeroSlider from '.././home/HeroSlider';
import CategorySlider from '../../components/CategorySlider';
import ProductSections from '../../components/ProductSections';

import NewArrivals from '../../components/NewArrivals';
import ShopCategory from '../../components/ShopCategory';
import EverydayWardrobe from '../../components/EverydayWardrobe';
import ShopByCategory from '../ShopByCategory';
import './HomePage.css';

const HomePage = () => {
  const [settings, setSettings] = useState({
    hero_title: 'Welcome to ShopDemo',
    hero_subtitle: 'Discover amazing products at unbeatable prices'
  });

  // Load settings
  useEffect(() => {
    const loadSettings = async () => {
      try {
        const response = await fetch('https://demo-site.storii.com.pk/demo-api/public/get-settings.php');
        const data = await response.json();
        if (data.success && data.settings) {
          setSettings(prev => ({ ...prev, ...data.settings }));
        }
      } catch (error) {
        console.error('Error loading settings:', error);
      }
    };
    loadSettings();
  }, []);

  return (
    <div className="home-page">
      {/* Hero Slider Component */}
      <HeroSlider />

      {/* New Arrivals Slider Section */}
      <NewArrivals />

      {/* Category Section */}
      {/*
      <ShopCategory />
      */}
      <ShopByCategory />

      {/* Features Section */}
      <section className="features-section-home">
        <div className="features-container">
          <div className="features-grid">
            <div className="feature-item">
              <div className="feature-icon-wrapper">
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feature-icon-section">
                  <rect width="20" height="12" x="2" y="6" rx="2"></rect>
                  <circle cx="12" cy="12" r="2"></circle>
                  <path d="M6 12h.01M18 12h.01"></path>
                </svg>
              </div>
              <h4 className="feature-title">{settings.feature_cod_title || 'Cash on Delivery'}</h4>
              <p className="feature-desc">{settings.feature_cod_description || 'Pay when your order arrives'}</p>
            </div>
            <div className="feature-item">
              <div className="feature-icon-wrapper">
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feature-icon-section">
                  <path d="M14 18V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v11a1 1 0 0 0 1 1h2"></path>
                  <path d="M15 18H9"></path>
                  <path d="M19 18h2a1 1 0 0 0 1-1v-3.65a1 1 0 0 0-.22-.624l-3.48-4.35A1 1 0 0 0 17.52 8H14"></path>
                  <circle cx="17" cy="18" r="2"></circle>
                  <circle cx="7" cy="18" r="2"></circle>
                </svg>
              </div>
              <h4 className="feature-title">{settings.feature_delivery_title || 'Nationwide Delivery'}</h4>
              <p className="feature-desc">{settings.feature_delivery_description || 'Shipping across Pakistan'}</p>
            </div>
            <div className="feature-item">
              <div className="feature-icon-wrapper">
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feature-icon-section">
                  <path d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"></path>
                  <path d="m9 12 2 2 4-4"></path>
                </svg>
              </div>
              <h4 className="feature-title">{settings.feature_payment_title || 'Secure Payments'}</h4>
              <p className="feature-desc">{settings.feature_payment_description || 'Online payment supported'}</p>
            </div>
            <div className="feature-item">
              <div className="feature-icon-wrapper">
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feature-icon-section">
                  <path d="M2.992 16.342a2 2 0 0 1 .094 1.167l-1.065 3.29a1 1 0 0 0 1.236 1.168l3.413-.998a2 2 0 0 1 1.099.092 10 10 0 1 0-4.777-4.719"></path>
                </svg>
              </div>
              <h4 className="feature-title">{settings.feature_whatsapp_title || 'WhatsApp Support'}</h4>
              <p className="feature-desc">{settings.feature_whatsapp_description || 'Need help? Chat with us'}</p>
            </div>
          </div>
        </div>
      </section>

      {/* EverydayWardrobe Section */}
      <EverydayWardrobe />

    </div>
  );
};

export default HomePage;